// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "ddc8e1499f69aa2c3b5e" + ".chunk.js";
};